import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`

/**
 * 网格机构管理
 * start
 */
// 分页查询网格机构列表
export function getBlockOrganizationListPage(params) {
  return request({
    url: url + '/gh-block-organization/getBlockOrganizationListPage',
    method: 'post',
    data: params
  })
}
// 添加网格机构
export function addBlockOrganization(params) {
  return request({
    url: url + '/gh-block-organization/addBlockOrganization',
    method: 'post',
    data: params
  })
}
// 删除网格机构
export function delBlockOrganization(params) {
  return request({
    url: url + '/gh-block-organization/delBlockOrganization',
    method: 'post',
    data: params
  })
}
// 修改网格机构
export function updateBlockOrganization(params) {
  return request({
    url: url + '/gh-block-organization/updateBlockOrganization',
    method: 'post',
    data: params
  })
}
// 获取网格机构
export function getBlockOrganizationById(params) {
  return request({
    url: url + '/gh-block-organization/getBlockOrganizationById',
    method: 'get',
    params
  })
}
// 查询所有公共服务类型列表
export function getPublicServiceTypeListAll(params) {
  return request({
    url: url + '/gh-pubilc-service-type/getPublicServiceTypeListAll',
    method: 'get',
    params
  })
}
// 文件上传
export function uploadFile(params) {
  return request({
    url: url + '/file/uploadFile',
    method: 'post',
    data: params
  })
}
/**
 * 网格机构管理
 * end
 */
/**
 * 网格长留言管理
 * start
 */
// 分页查询网格留言列表
export function getPointLeaveMessageListPage(params) {
  return request({
    url: url + '/gh-point-leave-message/getPointLeaveMessageListPage',
    method: 'post',
    data: params
  })
}
// 获取网格留言
export function getPointLeaveMessageById(params) {
  return request({
    url: url + '/gh-point-leave-message/getPointLeaveMessageById',
    method: 'get',
    params
  })
}
// 回复网格留言
export function replyPointLeaveMessage(params) {
  return request({
    url: url + '/gh-point-leave-message/replyPointLeaveMessage',
    method: 'post',
    data: params
  })
}
// 审核网格留言（通过-不通过）
export function updatePointLeaveMessageById(params) {
  return request({
    url: url + '/gh-point-leave-message/updatePointLeaveMessageById',
    method: 'post',
    data: params
  })
}
/**
 * 网格长留言管理
 * end
 */



// WEBPACK FOOTER //
// ./src/api/block.js